import axios from 'axios';
import state from '../state';

export default {

    getHealthScoresByAccount({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: '/api/communication/health-scores-by-account', method: 'GET'})
                .then(({data}) => {
                    commit('SET_HEALTH_SCORES_BY_ACCOUNT', data.accounts || {});
                    resolve(data);
                }).catch((err) => {
                    reject(err && err.response && err.response.data);
                });
        })
    },

    getManagerHealthAvg(ctx, payload) {
        const period = (payload && payload.period) || 'day';
        const mid = payload && payload.managerId ? '&manager_id=' + payload.managerId : '';
        const acc = (payload && payload.accountIds && payload.accountIds.length)
            ? '&account_ids=' + payload.accountIds.join(',') : '';
        const mon = (payload && payload.month) ? '&month=' + payload.month : '';
        return new Promise((resolve, reject) => {
            axios({url: '/api/communication/manager-health-avg?period=' + period + mid + acc + mon, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch((err) => {
                    reject(err && err.response && err.response.data);
                });
        })
    },

    getBudgets({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-budgets', data: payload,  method: 'POST'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    getBudgetsFilter({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-budgets-filter', data: payload,  method: 'POST'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    getAccounts({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-accounts', method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    getAccountErrors({commit}, payload) {
        var link = payload.id;
        if(payload.timestamp){
            link = link + '/' + payload.timestamp;
        }
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/ads-info/'+ link, method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    updateGoogleAccounts({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-accounts-update', method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    updateGoogleAccountStatus({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-status-update', data: payload,  method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    updateGoogleCommunications({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-communications-update', data: payload,  method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    communicationsOverview({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-communications-overview', data: payload,  method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    redFlagClient({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + payload.url, data: {reason: payload.reason}, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response ? response.data : {});
            });
        })
    },
    markDrop({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/manager-activity-drop-mark', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response ? response.data : {});
            });
        })
    },
    markThread({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/manager-activity-mark', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response ? response.data : {});
            });
        })
    },

    managerActivityLive({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/manager-activity-live', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    activity({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-activity', data: payload,  method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    editGoogleAccount({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-account/edit/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    updateGoogleAccount({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/google-account/update/' + payload.id,
                data: payload.data,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    storeGroup({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-groups/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    storeTag({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/google-tags/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
